import React from 'react';

import { Container, TitleText, SubTitleText, Acronym, Description, LegendsWrap, LegendContainer } from './styles';

function Title({ title, subTitle, legends }) {
  return (
    <Container>
      <TitleText>
        {title}
      </TitleText>
      {subTitle && (
        <SubTitleText>
          {subTitle}
        </SubTitleText>
      )}
      {legends?.length > 0 && (
        <LegendsWrap>
          {legends.map(
            legend => (
              <LegendContainer key={legend.description}>
                <Acronym>
                  {legend.acronym}{' - '}
                </Acronym>
                <Description>
                  {legend.description}
                </Description>
              </LegendContainer>
            )
          )}
        </LegendsWrap>
      )}
    </Container>
  );
}

export default Title;
